import React, { useCallback } from 'react';
// store
import { useSelector } from 'react-redux';
import { getFollowers } from '../../store/modules/followers';
// components
import { Table } from '../../components';
import { columns } from '../Users/Users';
import DatePickers from '../../components/DatePickers';
// hooks
import useDatePickers from '../../components/DatePickers/useDatePicker';
// styles
import styles from './Followers.module.css';

const actions = ({ onUserDetails }) => [
  () => ({
    name: 'User details',
    onClick: onUserDetails,
  }),
];

export const FollowersPage = ({ history, match }) => {
  const followers = useSelector((state) => state.followers);
  const { startDate, endDate, setStartDate, setEndDate } = useDatePickers();

  const onUserDetails = (rowData) => history.push(`/admin/users/${rowData.id}`);

  const handlerSearchParams = useCallback(
    ({ params, search }) => ({
      $and: [
        { 'user.id': match.params.id },
        !search && {
          createdAt: {
            $gte: startDate.toISOString(),
          },
        },
        !search && {
          createdAt: {
            $lte: endDate.toISOString(),
          },
        },
        params,
      ],
    }),
    [match, startDate, endDate],
  );

  return (
    <div>
      <h1 className={styles.title}>Followers</h1>

      <DatePickers
        startDate={startDate}
        endDate={endDate}
        setStartDate={setStartDate}
        setEndDate={setEndDate}
      />

      <Table
        getData={getFollowers}
        data={followers}
        columns={columns}
        actions={actions({ onUserDetails })}
        searchParams={handlerSearchParams}
      />
    </div>
  );
};
